export default __webpack_public_path__ + "src/images/packages/villa-54-victoria/600eea40a4dee31f5f47d5e396490093-1.jpg";